var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"pagin-block\"><div class=\"quantity\"><p>Showing&nbsp;<span class=\"quanQu\">{{ start }}&nbsp;</span><!--index of first item-->to&nbsp;<span class=\"quanTo\">{{ end }}&nbsp;</span><!--index of last item-->of&nbsp;<span class=\"quanOf\">{{total}}</span></p></div><div style=\"float: right;\"><paging page=\"currentPage\" page-size=\"options.limit\" total=\"total\" paging-action=\"pageChanged('paginate',page)\" show-prev-next=\"true\" text-next=\"Next\" text-prev=\"Prev\" ul-class=\"appbundle-paging\" active-class=\"current\" disabled-class=\"disabled\"></paging></div><div class=\"cf\"></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/pagination/pagination.jade
// module id = 544
// module chunks = 0